import { useListEquipmentTypes } from "#src/components/hooks/adapters/useEquipment";
import { DropdownInput } from "@validereinc/common-components";
import React from "react";

export const EquipmentTypeDropdownInput = ({
  name = "type",
  label,
}: {
  name: string;
  label?: string;
}) => {
  const equipmentTypes = useListEquipmentTypes({}).data?.data ?? [];
  return (
    <DropdownInput
      label={label}
      name={name}
      options={equipmentTypes}
      placeholder="Select Type..."
      labelKey="name"
      valueKey="id"
      isFluid
      isSearchable
      isSortedAlphabetically
      isOptionalTextShown={false}
    />
  );
};
